import { Input, MonthPicker, SearchIcon, Select } from "@jutro/ui";
import dayjs, { Dayjs } from "dayjs";
import { Dispatch, SetStateAction } from "react";
import { AnimatedFiltersWrapper } from "components/AnimatedHeaderOnScrollWrapper/AnimatedFiltersWrapper";
import { useVojevodshipOptions } from "lib/hooks/useVojevodshipOptions";
import {
  StaffGenreFilter,
  staffGenreFilterOptions,
} from "views/StaffSchedule/tools";

type Props = {
  isScrolled: boolean;
  startDate: Dayjs;
  selectedOrganizationId: string;
  selectedStaffGenre: StaffGenreFilter;
  searchInputValue: string;
  setStartDate: Dispatch<SetStateAction<Dayjs>>;
  setSelectedOrganizationId: Dispatch<SetStateAction<string>>;
  setSelectedStaffGenre: Dispatch<SetStateAction<StaffGenreFilter>>;
  setSearchInputValue: Dispatch<SetStateAction<string>>;
};

export const StaffScheduleFilters = ({
  isScrolled,
  startDate,
  selectedOrganizationId,
  selectedStaffGenre,
  searchInputValue,
  setStartDate,
  setSelectedOrganizationId,
  setSelectedStaffGenre,
  setSearchInputValue,
}: Props) => {
  const { organizationsClinicsOptions } = useVojevodshipOptions();

  return (
    <AnimatedFiltersWrapper isScrolled={isScrolled}>
      <div className="flex w-full flex-wrap items-center justify-between gap-4">
        <div className="z-100 flex gap-4">
          <MonthPicker
            value={startDate.toDate()}
            onChange={(date) => {
              const stringDate = date?.toString();
              setStartDate(dayjs(stringDate).startOf("month"));
            }}
            onLeftArrowClick={() =>
              setStartDate((prev) => prev.subtract(1, "month").startOf("month"))
            }
            onRightArrowClick={() =>
              setStartDate((prev) => prev.add(1, "month").startOf("month"))
            }
          />
          <div className="w-72">
            <Select
              value={
                organizationsClinicsOptions.find(
                  (o) => o.value === selectedOrganizationId,
                ) ?? null
              }
              options={organizationsClinicsOptions}
              placeholder="Wybierz placówkę"
              onChange={(org) =>
                // Delay setting the selected option to ensure the select options close
                setTimeout(
                  () => setSelectedOrganizationId(org?.value ?? ""),
                  200,
                )
              }
            />
          </div>

          <div className="w-72">
            <Select
              value={
                staffGenreFilterOptions.find(
                  ({ value }) => value === selectedStaffGenre,
                ) ?? null
              }
              options={staffGenreFilterOptions}
              onChange={(option) =>
                // Delay setting the selected option to ensure the select options close
                setTimeout(
                  () => setSelectedStaffGenre(option?.value ?? "ALL"),
                  200,
                )
              }
            />
          </div>

          <div className="w-72">
            <Input
              value={searchInputValue}
              height="sm"
              maxLength={30}
              placeholder="Szukaj..."
              sideElement={<SearchIcon size="sm" />}
              sideElementPosition="end"
              onChange={(e) => setSearchInputValue(e.target.value)}
            />
          </div>
        </div>
      </div>
    </AnimatedFiltersWrapper>
  );
};
